'use client';

import clsx from 'clsx';

type TabProps = React.PropsWithChildren & {
	tabKey?: string;
	name: string;
	title: React.ReactNode;
	cache?: boolean;
	active?: boolean;
	onClick?: () => void;
};

export const Tab = ({ title, active, ...props }: TabProps) => {
	return (
		<div
			className={clsx(
				{
					'border-b-transparent text-gray-3 hover:text-gray-1': !active,
					'border-b-black text-gray-1': active,
				},
				'block cursor-pointer text-nowrap border-b px-6 py-2 text-center text-sm md:px-6 md:py-3',
			)}
			{...props}
		>
			{title}
		</div>
	);
};
